import { render, staticRenderFns } from "./FieldsetProjectGeneral.yaml?vue&type=template&id=56247732&component"
import script from "./FieldsetProjectGeneral.yaml?vue&type=script&lang=ts&component"
export * from "./FieldsetProjectGeneral.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports